/* template */
<template><div class="pay-card-record-wrap"><div :style="(cardHeaderBg)" class="card-header-wrap"><div class="card-header-content"><div class="card-sub-script"><type-subscript :cardData="(cardData)"/></div></div><div :class='("tag-bar "+(tagBarCss))' v-if="(statusText)">{{ statusText }}</div></div><div class="card-middle-wrap"><div class="card-title-wrap"><div class="card-validity-title" v-if="(cardData.coupons)">券类型</div><div class="card-validity-title">有效期</div><div class="card-validity-title">实付款</div></div><div class="card-value-wrap"><div class="card-opening-date" v-if="(cardData.coupons)">{{ cardData.coupons }}</div><template><div class="card-opening-date" v-if="(cardData.status === EnumCardType.PenddingValid)">助力中 待生效</div><div class="card-opening-date" v-else-if="(cardData.status === EnumCardType.AssistFailRefunded)">助力失败</div><div class="card-opening-date" v-else-if="(cardData.status === EnumCardType.AssistFailRefunding)">助力失败 退款中</div><div class="card-opening-date" v-else-if="(cardData.status === EnumCardType.AutomaticRenewal)">续费-自动扣费</div><div class="card-opening-date" v-else>{{ cardData.start_at }} 一 {{ cardData.expire_at }}</div></template><div class="card-opening-date">¥{{ cardData.price / 100 }}</div></div></div><mpx-view @tap="goToHelp" class="sale-entry" v-if="(saleEntryShow)">申请售后</mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3e0032df"}'>
@import '../../lib/stylus/variable.styl'

.pay-card-record-wrap
  width 681rpx
  // margin 34rpx auto
  box-shadow 0px 10px 20px 0px rgba(220,220,220,0.49)
  border-radius 40rpx 13rpx 13rpx 13rpx
  overflow hidden
  position relative
  z-index 1
  background #fff
  .card-header-wrap
    position relative
    .card-header-content
      display flex
      height 72rpx
      .card-sub-script
        height 72rpx
      .card-price
        font-family Barlow-ExtraBoldItalic
        font-size 24rpx
        color #000000
        letter-spacing 0
        line-height 72rpx
        font-weight 700
        transform translateX(-30rpx)
        span
          font-size 22rpx
          letter-spacing 0
          font-weight 600
    .tag-bar
      position absolute
      right -56rpx
      top 10rpx
      width 188rpx
      height 55rpx
      text-align center
      line-height 55rpx
      transform rotate(-319deg)
      background-image linear-gradient(164deg, #EC4135 0%, #FF7266 83%)
      font-size 22rpx
      color #FFFFFF
      letter-spacing 0
      &.invaild-tag
        background-image linear-gradient(222deg, #E6E6E6 14%, #DEDEDE 95%)
        color #1B1B1B
  .card-middle-wrap
    display flex
    font-size 22rpx
    color #575757
    padding 31rpx 0rpx 35rpx 35rpx
    .card-title-wrap
      display flex
      flex-direction column
      margin-right 32rpx
      .card-validity-title
        margin-bottom 11rpx
        line-height 31rpx
    .card-value-wrap
      display flex
      flex-direction column
      .card-opening-date
        margin-bottom 11rpx
        line-height 31rpx
      // .card-validity-date
      //   margin-bottom 15rpx
      //   vertical-align middle
  .sale-entry
    position absolute
    bottom 35rpx
    right 30rpx
    opacity 0.4
    font-size 20rpx
    color #000000
    line-height 24rpx
    font-weight 400
    &:after
      position absolute
      right -8rpx
      bottom 6rpx
      content ''
      width 8rpx
      height 8rpx
      border-top 1rpx solid
      border-right 1rpx solid
      transform rotate(45deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { EnumCardType, EnumPartitionID } from '@/lib/webx/defines'
import { throttle } from '../../lib/js/util'
import { GlobalEnv, URLQueries } from '../../lib/webx'
import { goTo } from '@didi/webx-js'

createComponent({
  watch: {},
  properties: {
    cardData: {
      type: Object,
      value: {},
    },
    cityId: [ String, Number ],
    returnUserInfo: {
      type: Object,
      value: {},
    },
  },
  data: {
    EnumCardType,
  },
  computed: {
    cardHeaderBg(){
      // 1 未开通 2 已开通有效期内 3 已过期 4 即将过期  5 已退款
      if (this.cardData.status === 2 || this.cardData.status === 4) {
        return 'background-image: linear-gradient(270deg, #FFFFFF 0%, #FFEBDE 49%);'
      } else {
        return 'background-image: linear-gradient(-24deg, #FFFFFF 0%, #E8E8E8 66%);'
      }
    },
    statusText() {
      switch(this.cardData?.status) {
        case EnumCardType.NotOpen:
          return '未开通'
        case EnumCardType.OpeningAndVaild:
        case EnumCardType.ExpiringSoon:
        case EnumCardType.AutomaticRenewal:
          return '生效中'
        case EnumCardType.Overdue:
          return '已过期'
        case EnumCardType.Refunded:
        case EnumCardType.AssistFailRefunded:
          return '已退款'
        case EnumCardType.PenddingValid:
          return '待生效'
        default:
          return ''
      }
    },
    tagBarCss(){
      const vaildStatus = this.cardData.status === EnumCardType.OpeningAndVaild || this.cardData.status === EnumCardType.ExpiringSoon || this.cardData.status === EnumCardType.PenddingValid
      return vaildStatus ? '' : 'invaild-tag'
    },
    saleEntryShow() {
      if (this.cardData?.partition_id === EnumPartitionID.PremierMember) return false
      return [ EnumCardType.OpeningAndVaild, EnumCardType.ExpiringSoon, EnumCardType.PenddingValid, EnumCardType.Overdue ].includes(this.cardData?.status)
    },
  },
  methods: {
    getDchn(url) {
      const DCHN_LINK_REGEX = [
        /^(http(s?):\/\/)?((v(-hk)?\.)?didi\.cn|((m|x)\.)?huaxz\.cn)\/([A-Za-z])\//,
        /^(http(s?):\/\/)?((v(-hk)?\.)?didi\.cn|((m|x)\.)?huaxz\.cn)\//,
        /^(http(s?):\/\/)?v(-hk)?\.(udache\.com|xiaojukeji\.com)/,
        /^(http(s?):\/\/)?x\.(diditaxi\.com\.cn|kuaidadi\.com)/,
        /^(http(s?):\/\/)?es\.xiaojukeji\.com\/([A-Za-z])\//,
        /^(http:\/\/)?v-test.intra.xiaojukeji.com\/([A-Za-z]\/)?/,
        /^(http(s?):\/\/)?vstage-pre.intra.xiaojukeji.com\/([A-Za-z]\/)?/,
        /^(http:\/\/)?v-dev.didi.cn(\/)?([A-Za-z]\/)?/,
        /^(http:\/\/)?osim(\d{3}).v.osim.intra.xiaojukeji.com(\/)?([A-Za-z]\/)?/,
      ]
      let dchn = ''
      if (DCHN_LINK_REGEX.some(regex => regex.test(url))) {
          const splitUrl = url.split('/')
          const key = splitUrl[splitUrl.length - 1]
          dchn = key && key.indexOf('?') ? key.split('?')[0] : key
      }
      return dchn
    },
    goToHelp: throttle(function() {
      // let url = 'https://page.udache.com/wyc-webx/wyc-purchase-common/help.html'
      // if (!process.env.ONLINE) {
      //   url = 'http://10.190.7.204:8080/wyc-webx/pay-card/wyc-purchase-common/help.html'
      // }
      const dchn = this.getDchn(this.cardData.material.detail_url)
      goTo({
        url: 'https://page.udache.com/wyc-webx/wyc-purchase-common/help.html',
        params: {
          goods_id: this.cardData?.goods_id,
          order_id: this.cardData?.order_id,
          prod_key: 'wyc-pay-card-template',
          need_track: true,
          cityId: this.cityId,
          token: GlobalEnv.loginInfo.token,
          superior_dchn: URLQueries.getQuery('dchn'),
          u_att_id: this.returnUserInfo.uid,
          partition_id: this.cardData?.partition_id,
          dchn,
        },
      })
    }, 500),
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "pay-card-record3e0032df",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'type-subscript':getComponent(require("./type-subscript.mpx?component=true&componentId=type-subscript3ef92790")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
